module.exports = __webpack_public_path__ + "img/video2.aa8e36be.png";